import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
import Price from "../../Price/Price/Price.js";
/* empty css              */
const PriceTag = ({
  originalPrice,
  originalCentAmount = true,
  discountedPrice,
  discountedCentAmount = true,
  currency = "EUR",
  className,
  prefix
}) => {
  const { getLabel } = useIntl();
  const showDiscount = typeof discountedPrice !== "undefined";
  return /* @__PURE__ */ React.createElement("span", { className: classnames("price-tag", className), "data-t": "price-tag" }, prefix ? /* @__PURE__ */ React.createElement("span", { className: "price-tag__prefix" }, prefix) : null, discountedPrice !== originalPrice && /* @__PURE__ */ React.createElement(
    Price,
    {
      "aria-label": showDiscount ? getLabel("common.originalPrice") : void 0,
      value: originalPrice,
      centAmount: originalCentAmount,
      currency,
      type: showDiscount ? "strikethrough" : "default",
      className: "price-tag__price"
    }
  ), showDiscount && /* @__PURE__ */ React.createElement(
    Price,
    {
      "aria-label": getLabel("common.discountedPrice"),
      value: discountedPrice,
      centAmount: discountedCentAmount,
      currency,
      type: "discount",
      className: "price-tag__price"
    }
  ));
};
export {
  PriceTag as default
};
//# sourceMappingURL=PriceTag.js.map
